import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Theme } from '@mui/material/styles';

import Typography from '@mui/material/Typography';
import {BaseCard} from '../../../components/wizard';
import { Box } from '@mui/material';

const s:any ={
  done: {
    m: 1,
    backgroundColor: '#28dab6',
    color: '#fffff',
    width: '36px',
    height: '36px',
  },
  success: {
    color: '#28dab6'
  }
};

class CloseCard extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.props.deb.log("CloseCard");
    this.state = {
      next: false,
      fwopen: false
    };
  }
  
  // handleProgress = (ev:any,perc:any)  => {
  //   //DO NOTHING
  // }

  // handleNext = (ev) => {
  //   this.props.setNext(this.props.name);
  // }

  // handleCancel = (ev) => {
  //   //this.props.switchFn('intro');
  // }

  // handleDone = (ev) => {
  //   window.location.href = this.ui.URL;
  // }

  render = () => {
    const message = "Process completed successfull. Thank you. Bye!";
    const { classes, theme, ...extraProps  } = this.props;  
    return (
      <Box>
        <BaseCard
          cardid={'CLOSE'}
          cardname={'close'}
          cardtitle={'Exit'}
          instruction={'Complete wizard'}
          step={5}
          buttons={['DONE','GUIDE']}
          {...extraProps}
        >
          <Typography>
            {message}
          </Typography>
        </BaseCard>
      </Box>
    );
  }
}

CloseCard.propTypes = {
  //classes: PropTypes.object.isRequired,
};

export default CloseCard; 